import { connect } from 'react-redux';
import { getChangesValidation } from '../../reducers/changes';
import TextInputComponent from '../../components/StewardAssetEdit/TextInput';
import TextBoxInputComponent from '../../components/StewardAssetEdit/TextBoxInput';
import SelectInputComponent from '../../components/StewardAssetEdit/SelectInput';
import FileInputComponent from '../../components/StewardAssetEdit/FileInput';

function mapStateToProps(state, ownProps) {
  return {
    validation: getChangesValidation(state, ownProps.changeRef, ownProps.field)
  };
}

const TextInput = connect(mapStateToProps)(TextInputComponent);
const TextBoxInput = connect(mapStateToProps)(TextBoxInputComponent);
const SelectInput = connect(mapStateToProps)(SelectInputComponent);
const FileInput = connect(mapStateToProps)(FileInputComponent);

export { TextInput, TextBoxInput, SelectInput, FileInput };
